class NumberAbbreviation {
  constructor(lang, translationMap) {
    this.lang = lang;
    this.cached = {};
    this.translationMap = translationMap;
  }

  abbr(value) {
    const configValue = localStorage.getItem('dashboard-abbr');
    if (configValue === 'random') {
      value = (Math.random() * 1000) * Math.pow(10, Math.floor(Math.random() * 5));
    } else if (configValue) {
      value = configValue;
    }

    const full = this.getFormatter().format(value);
    const parts = this.getFormatter({
      notation: 'compact',
      minimumFractionDigits: 0,
      maximumFractionDigits: 1,
      maximumSignificantDigits: 3,
    }).formatToParts(value);

    const ret = {value: '', full, postfix: '', separator: ''};
    for (const part of parts) {
      if (part.type === 'integer' || part.type === 'group' || part.type === 'decimal' || part.type === 'fraction') {
        ret.value += part.value;
      } else if (part.type === 'compact') {
        ret.postfix = part.value;
      } else if (part.type === 'literal') {
        ret.separator = part.value;
      }
    }

    return ret;
  }

  /**
   * @param options
   * @return Intl.DateTimeFormat
   */
  getFormatter(options) {
    const lang = localStorage.getItem('dashboard-lang') || this.lang;
    const key = JSON.stringify([lang, options]);
    if (!this.cached[key]) {
      this.cached[key] = new Intl.NumberFormat(lang, options);
    }
    return this.cached[key];
  }
}

export {NumberAbbreviation};
